import template from './switch-auth.html';

export function switchAuth() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    scope: {
      session: '=',
      switched: '&'
    }, 
    link: function(scope, element, attrs) {
      let session = scope.session;
      let input = element.find('input')[0];
     
      if (session.hasTransactionPasswordEnabled) {
        input.placeholder = scope.placeholder = 'Enter Transaction Password';
      }

      if (session.isUsingGoogleTwoFactor) {
        input.placeholder = scope.placeholder = 'Enter G-Auth Code';
      }

      scope.isUsingGoogleTwoFactor = scope.session.isUsingGoogleTwoFactor;
      scope.shouldShowSwitch = scope.session.hasSetupAllTransactionAuthentication();

      scope.switched({isUsingGoogleTwoFactor: scope.isUsingGoogleTwoFactor});
      scope.switchAuthenticationMode = function() {
        scope.isUsingGoogleTwoFactor = !scope.isUsingGoogleTwoFactor;
        input.placeholder = scope.isUsingGoogleTwoFactor ? 'Enter G-Auth Code' : 'Enter Transaction Password';
        scope.switched({isUsingGoogleTwoFactor: scope.isUsingGoogleTwoFactor});
      }
    },
    template: template
  };
};

export default switchAuth;




// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/directive/switch-auth.directive.js